// External partners (agencies) — see backend/auth/partners.py.
//
// A partner is an editor who works across all content and leads, including
// contact details. The API answers 403 PARTNER_SCOPE outside their allowlist
// (users, API keys, webhooks, app settings, error logs, audience extracts);
// these paths keep the UI to the screens that work for them.
import { useAuth } from '@/contexts/AuthContext';

export const isPartner = (user) => user?.auth_method === 'partner';

const PARTNER_PATHS = [
  '/dashboard',
  '/qrs',
  '/templates',
  '/editor',
  '/urls',
  '/pages',
  '/submissions',
  '/leads',
  '/page-templates',
  '/brand',
  '/bio',
  '/campaigns',
  '/utm-builder',
  '/media',
  '/analytics',
  '/conversions',
  '/experiments',
  '/workflows',
  '/settings',
  '/help',
];

export function partnerMayOpen(pathname) {
  return PARTNER_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}

// Region is mandatory on create forms, except for partners: they may leave a
// record national or link it, and the backend checks whatever they pick.
export function useRegionRequired() {
  const { user } = useAuth();
  return !isPartner(user);
}
